
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule/[day]",
      function () {
        return require("private-next-pages/schedule/[day].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule/[day]"])
      });
    }
  